module.exports = __webpack_public_path__ + "static/img/032_TO8_1514_og.28185fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/032_TO8_1514_og.jpg
// module id = Dz5n
// module chunks = 0